export const CARD_BASE_WIDTH = 164;
export const CARD_DM_WIDTH = 200;
export const SLIDE_SPACING = 16;

export const getCarouselItemsLimit = (windowWidth: number, swiperWidth: number): number => {
    const breakpointWhereHideBullets = 1250;

    if (swiperWidth <= CARD_BASE_WIDTH * 2 + SLIDE_SPACING) return 9;
    if (swiperWidth <= CARD_BASE_WIDTH * 3 + SLIDE_SPACING * 2) return 15;
    if (windowWidth < breakpointWhereHideBullets) return 27;
    return Infinity;
};
